export const periodText = {
  perPeriodday_one: "per day",
  perPeriodday_other: "every {{count}} days",
  perPeriodweek_one: "per week",
  perPeriodweek_other: "every {{count}} weeks",
  perPeriodmonth_one: "per month",
  perPeriodmonth_other: "every {{count}} months",
  perPeriodyear_one: "per year",
  perPeriodyear_other: "every {{count}} years",
};

export function getBillingOrSessionCycleOptions(
  intervalType: string,
  interval: number,
) {
  return (
    periodText[
      `perPeriod${intervalType}_${interval === 1 ? "one" : "other"}`
    ]?.replace("{{count}}", String(interval)) ?? ""
  );
}
